<template>
  <v-card>
    <v-card-title><h3>Analytics</h3></v-card-title>
    <v-card-text>

      <v-layout row wrap>
        <v-flex xs12 md4 class="text-xs-center" px-1 mt-2>
          <v-flex>
            <v-select :items="users"
                      v-model="selectedUser"
                      label="Select user">
            </v-select>
          </v-flex>
        </v-flex>

        <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fromDate"
                  label="Period starts from:"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fromDate" @input="menu = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>

        <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="toDate"
                  label="Period end on:"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="toDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-flex xs12 md12>
            <v-data-table
              :items="completedCases"
              :headers="analyticHeaders"
              :loading="loading"
              :expand="expand"
              item-key="id"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded" class="grey lighten-2">
                  <td>{{ props.item.manager_name }}</td>
                  <td>{{ props.item.cases.length }}</td>
                  <td>{{ props.item.commission }}</td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-data-table
                  :items="props.item.cases"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <td>Case ID: {{ props.item.id }}</td>
                    <td>Case Name: {{ props.item.name }}</td>
                    <td><span v-if="props.item.services.length">Services: </span>{{ _.map(props.item.services, 'service.name').join(',') }}</td>
                    <td>Commissions: {{ props.item.commissions }}</td>
                  </template>
                </v-data-table>
              </template>
            </v-data-table>
          </v-flex>
        </v-flex>
      </v-layout>

    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    computed: {
      ...mapGetters({
        users: 'allUsersFull',
        allCompletedCases: 'getAllCompletedGroupedCases'
      })
    },
    data () {
      return {
        menu: false,
        menu1: false,
        fromDate: null,
        toDate: null,
        expand: false,
        selectedUser: null,
        completedCases: [],
        analyticHeaders: [
          { text: 'User', value: 'user.name' },
          { text: 'Completed Cases', value: 'cases.length' },
          { text: 'Commission', value: 'commission' }
        ],
        loading: true
      }
    },
    watch: {
      selectedUser (user) {
        const caseManager = this.users.find(i => i.id === user)
        this.completedCases = this.mapCases(this.allCompletedCases(this.fromDate, this.toDate, caseManager.name))
        this.fromDate = this.toDate = null
      },
      fromDate () {
        this.completedCases = this.mapCases(this.allCompletedCases(this.fromDate, null, this.selectedUser))
      },
      toDate () {
        this.completedCases = this.mapCases(this.allCompletedCases(null, this.toDate, this.selectedUser))
      }
    },
    methods: {
      mapCases (cases) {
        return _.map(cases, (u) => {
          return {
            id: u[0].user.id,
            manager_name: u[0].manager_name,
            user: u[0].user,
            cases: u,
            commission: _.sumBy(u, 'commissions')
          }
        })
      }
    },
    created () {
      this.$store.dispatch('loadAllCases').then(() => {
        this.loading = false
        this.completedCases = this.mapCases(this.allCompletedCases(null, null, null))
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Analytics.vue?56afb7a1